import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";

const path = `${baseUrl}/company-weight`;

export const { useGetAll: useAllCompanyWeight } = apiCrudBuilder(
  path,
  "CompanyWeight",
);
